import React from 'react';

export default function TeamIcon(props) {
  return (
    <svg width={props.width || "18"} height={props.height || "17"} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17 15.4V13.8C17 12.3089 15.9802 11.056 14.6 10.7008M11.8 1.23261C12.9727 1.70732 13.8 2.85705 13.8 4.2C13.8 5.54295 12.9727 6.69268 11.8 7.16739M13 15.4C13 13.909 13 13.1635 12.7564 12.5754C12.4316 11.7913 11.8087 11.1684 11.0246 10.8436C10.4365 10.6 9.69101 10.6 8.2 10.6H5.8C4.30899 10.6 3.56348 10.6 2.97541 10.8436C2.19132 11.1684 1.56837 11.7913 1.24359 12.5754C1 13.1635 1 13.909 1 15.4M10.2 4.2C10.2 5.96731 8.76731 7.4 7 7.4C5.23269 7.4 3.8 5.96731 3.8 4.2C3.8 2.43269 5.23269 1 7 1C8.76731 1 10.2 2.43269 10.2 4.2Z" stroke="#5A646E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
